import { Notification as NotificationType } from "./types";
import { Notification } from "./Notification";
import styles from "./Notifications.module.css";
interface NotificationsProps {
  notifications: NotificationType[];
  onDismiss: (id: string) => void;
  timeout: number;
}
function Notifications(props: NotificationsProps) {
  const notifications = props.notifications.map((notification, i) => {
    return <Notification index={i} key={notification.id} notification={notification} onDismiss={props.onDismiss} timeout={notification.timeout ?? props.timeout} />;
  });
  return <section className={styles.root} data-test="notifications" data-sentry-component="Notifications" data-sentry-source-file="Notifications.tsx">
      {notifications}
    </section>;
}
export default Notifications;